import React, { Component, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header/Header";
import "./App.css";
import NothingThere from "./components/404/NothingThere";
import AuthController from "./auth/AuthController";
import Landing from "./components/Landing/Landing";
import Footer from "./components/Footer/Footer";

export default class App extends Component {
  constructor(props: any) {
    super(props);
    document.title = "acami - Support";
  }

  render() {
    return (
      <Router>
        <Suspense fallback={null}>
          <Header />
          <div className={"content-container"}>
            <Switch>
              <Route path="/auth">
                <AuthController />
              </Route>
              <Route path="/">
                <Landing />
              </Route>
              <Route>
                <NothingThere />
              </Route>
            </Switch>
          </div>
          <Footer />
        </Suspense>
      </Router>
    );
  }
}
